module.exports = __webpack_public_path__ + "static/media/booking.75afca7a.svg";